<template>
  <Widget
    widgetName="top-routine-by-findings"
    :customParams="customParams"
    @dataFetched="handleDataFetched"
    @locationOptionChange="handleLocationOptionChange"
  >
    <template v-slot:content>
      <div class="d-flex flex-column h-100 align-center justify-center">
        <div class="w-100 px-3">
          <v-row class="ma-0 pa-0 justify-center">
            <v-tooltip bottom v-for="routine in routines" :key="routine.id">
              <template v-slot:activator="{ on }">
                <v-col
                  v-on="routine.id ? on : null"
                  style="max-width: 33%; min-width: 173px;"
                  :cols="cols"
                  @click="goToRoutine(routine.id)"
                >
                  <Impact
                    class="routine-with-most-finding px-3"
                    hidePercentageChange
                    :routine="routine.name"
                    :id="routine.id"
                    :percentageChange="routine.percentageChange"
                    :metricText="getMetricText(routine.findingsCount)"
                  />
                </v-col>
              </template>
              {{ $t('insights.view_routine') }}
            </v-tooltip>
          </v-row>
        </div>
      </div>
    </template>
  </Widget>
</template>

<script>
import Widget from './SharedComponents/WidgetBase.vue'
import Impact from './SharedComponents/RoutinesImpact.vue'

import trackerMixin from '@/mixins/tracking/trackerMixin.vue'
import mixin from '@/mixins/mixin.vue'

const ROUTINES_INSIGHT_DEFAULT_SIZE = 6

export default {
  name: 'RoutinesWithMostFindings',

  mixins: [mixin, trackerMixin],

  components: {
    Widget,
    Impact,
  },

  data() {
    return {
      ROUTINES_INSIGHT_DEFAULT_SIZE,
      customParams: { limit: 6 },
      selectedSiteId: null,
      routines: [],
    }
  },

  computed: {
    cols() {
      if (this.$vuetify.breakpoint.xs) return 12

      const length = this.routines.length

      if ([1, 2, 4].includes(length)) return 6

      return 4
    },
  },

  methods: {
    goToRoutine(id) {
      if (!id) return
      this.trackInsightsWidgetNavigate({
        widget: 'top-routine-by-findings',
        action: 'goToRoutine',
        routine: id,
      })
      this.openInNewTab({
        name: 'routineDefinitionView',
        params: {
          routineId: id,
        },
      })
    },

    formatNumber(value) {
      return Intl.NumberFormat('en-us', {
        notation: 'compact',
        maximumFractionDigits: 1,
      }).format(value)
    },

    getMetricText(findings) {
      if (!findings) return '-'
      return this.$t('insights.findings_with_count', {
        count: findings,
        countText: this.formatNumber(Number(findings)),
      })
    },

    handleLocationOptionChange(option) {
      this.selectedSiteId = option
    },

    async handleDataFetched(widget) {
      this.routines = [...widget.data]
    },
  },
}
</script>
<style lang="scss">
.routine-with-most-finding {
  border-radius: 4px;
  &:hover {
    background: $color-blue-grey-lighten3;
    cursor: pointer;
  }
}
</style>
